import { ProjectKind } from "../../../enums/ProjectKind";

export const kindToString = (kind: ProjectKind) =>
  kind === ProjectKind.Film ? "film" : "series";
